import Phaser from 'phaser';
import { ensureGroundTextures } from '../render/themes';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload(): void {
    for (let i = 0; i < 12; i++) {
      this.load.image(`horse_run_${i}`, `assets/horse_frames/frame_${i}.png`);
    }
    for (let i = 0; i < 4; i++) {
      this.load.image(`pig_run_${i}`, `assets/pig_frames/frame_${i}.png`);
    }
    // Sheep: each AI frame is a visibly different sheep, so use a single frame
    // as a static sprite to avoid flicker between characters.
    this.load.image('sheep_run_0', 'assets/sheep_frames/frame_0.png');
    // Donkey: each AI frame faces a different direction, so use a single
    // right-facing frame as a static sprite to stop the flicker.
    this.load.image('donkey_run_0', 'assets/donkey_frames/frame_0.png');
    // The remaining animals also use a single static frame to avoid flicker
    // (every AI gen produces a slightly different-looking animal).
    for (const a of ['duck', 'otter', 'clownfish', 'stingray', 'turtle', 'seal']) {
      this.load.image(`${a}_run_0`, `assets/${a}_frames/frame_0.png`);
    }
    for (const b of ['wolf', 'serpent', 'bear', 'dragon']) {
      this.load.image(`boss_${b}`, `assets/boss_frames/${b}.png`);
    }
  }

  create(): void {
    ensureGroundTextures(this);

    this.anims.create({
      key: 'horse_run',
      frames: Array.from({ length: 12 }, (_, i) => ({ key: `horse_run_${i}` })),
      frameRate: 14,
      repeat: -1,
    });

    this.anims.create({
      key: 'pig_run',
      frames: Array.from({ length: 4 }, (_, i) => ({ key: `pig_run_${i}` })),
      frameRate: 8,
      repeat: -1,
    });

    // Sheep: single-frame animation (anim system used so it slots into the
    // same SPRITE_ANIMALS path as the other animals).
    this.anims.create({
      key: 'sheep_run',
      frames: [{ key: 'sheep_run_0' }],
      frameRate: 1,
      repeat: -1,
    });

    this.anims.create({
      key: 'donkey_run',
      frames: [{ key: 'donkey_run_0' }],
      frameRate: 1,
      repeat: -1,
    });

    for (const a of ['duck', 'otter', 'clownfish', 'stingray', 'turtle', 'seal']) {
      this.anims.create({
        key: `${a}_run`,
        frames: [{ key: `${a}_run_0` }],
        frameRate: 1,
        repeat: -1,
      });
    }

    this.scene.start('LaunchScene');
  }
}
